import { render, staticRenderFns } from "./PointsTransfer.vue?vue&type=template&id=0e9c5a96&scoped=true&"
import script from "./PointsTransfer.vue?vue&type=script&lang=js&"
export * from "./PointsTransfer.vue?vue&type=script&lang=js&"
import style0 from "./PointsTransfer.vue?vue&type=style&index=0&id=0e9c5a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9c5a96",
  null
  
)

export default component.exports